<form class="form-inline" layout="row">
  <div class="form-group">
    <div class="relative">
      <input
        [(ngModel)]="searchTerm"
        (ngModelChange)="searchChanged.emit(searchTerm)"
        [ngModelOptions]="{ standalone: true }"
        class="form-control"
        id="visit-search-field"
        type="text"
        placeholder="Visit#, Address"
      />
      <i class="icon-x-circle input-icon--right no-label" (click)="clearSearch()"></i>
    </div>
  </div>
</form>
